/**
 * @GENERATED from Figma node 693:15936
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const FrontBright = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill="#001B38"
        d="M4.727 5.328C4.727 3.49 6.275 2 8.185 2h11.088v4.736c0 .919-.774 1.664-1.73 1.664H13.04c-.918 0-1.662.716-1.662 1.6v10.336c0 .919-.774 1.664-1.73 1.664h-4.92z"
      />
      <path
        fill={`url(#${_id})`}
        d="M8.592 10.04c0 2.386 2.009 4.32 4.488 4.32s4.488-1.934 4.488-4.32-2.01-4.32-4.488-4.32-4.488 1.934-4.488 4.32"
      />
      <path
        fill={`url(#${_id2})`}
        d="M8.592 10.04c0 2.386 2.009 4.32 4.488 4.32s4.488-1.934 4.488-4.32-2.01-4.32-4.488-4.32-4.488 1.934-4.488 4.32"
        opacity={0.5}
      />
      <defs>
        <linearGradient
          id={_id}
          x1={9.919}
          x2={16.409}
          y1={6.802}
          y2={13.591}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0057" stopOpacity={0.16} />
          <stop offset={0.861} stopColor="#FF0057" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={9.919}
          x2={16.409}
          y1={6.802}
          y2={13.591}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0057" stopOpacity={0.16} />
          <stop offset={0.861} stopColor="#FF0057" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(FrontBright);
export { ForwardRef as FrontBright };
